// ENTITY fr.gestionpial.pial.dto.AeshAffectationActiveDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class AeshAffectationActiveDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.AeshAffectationActiveDTO';

  idAesh: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  nbAffectationsActives: number | null = 0;

  constructor(init?:Partial<AeshAffectationActiveDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.AeshAffectationActiveDTO'] = AeshAffectationActiveDTO;

fields['fr.gestionpial.pial.dto.AeshAffectationActiveDTO']  = {
    idAesh: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    nbAffectationsActives: 'java.lang.Integer'
};
